import React, { useState } from "react";
import "./Brand.css";
import { activationVideo, brandImages, brands } from "./brandItem";
import { Carousel } from "antd";
import BrandActivationVideo from "../../Component/BrandActivation/BrandActivation";
import { useNavigate, useSearchParams } from "react-router";
import BrandFilter from "./BrandFilter";

const BrandPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const type = searchParams.get("type") || "cycling";
  const [activeSlide, setActiveSlide] = useState(0);
  const filteredBrands = [...brands].filter((brand) => brand.type === type);

  return (
    <>
      <div className="layout brand-layout">
        <div className="container main-brand-container">
          <div className="brand-background">
            <h1 className="title main-brand-title">OUR BRANDS</h1>
            <p className="subtitle main-brand-subtitle">
              Our brands represent a shared vision of excellence
              <br />
              Delivering top-tier products for cycling and lifestyle enthusiasts
            </p>
          </div>

          <BrandFilter activeType={type} />
          <div className="brand-container">
            {filteredBrands.map((brand, index) => (
              <div className="brand-card">
                <img
                  className="brand-item"
                  src={brand.src}
                  alt={brand.alt}
                  key={index}
                />
              </div>
            ))}
          </div>
          {/* <div className="brand-footer-title subtitle" style={{ margin: "0" }}>
            and many more
          </div> */}
        </div>
        <div className="container brand-activation-container">
          <div className="brand-activation-image-wrapper">
            <Carousel
              arrows
              infinite
              fade
              autoplay
              autoplaySpeed={6000}
              effect="fade"
              speed={400}
              beforeChange={(current, next) => setActiveSlide(next)}
            >
              {brandImages.map((bImage, index) => (
                <div className="image-container" key={index}>
                  <img
                    className="image-item"
                    src={bImage.src}
                    alt={bImage.alt}
                  />
                </div>
              ))}
            </Carousel>

            {/* Overlay text */}
            <div className="brand-activation-overlay">
              <h1 className="title main-brand-title">BRAND ACTIVATION</h1>
              <p className="subtitle main-brand-subtitle">
                Dynamic events showcasing the spirit of our cycling brand
              </p>
            </div>
          </div>

          <div className="brand-activation-videos">
            {activationVideo.map((video, index) => (
              <>
                <BrandActivationVideo
                  src={video.src}
                  text={video.text}
                  inverted={video.inverted}
                />
              </>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default BrandPage;
